import { createElement } from 'react';
import type { Production } from 'sr-types/lib/search/v1/graphql';
import SortConfigFormItems from '../../../production/form/SortConfigFormItems';
import { ENTITIES } from '../../constants/customSortFieldConfigs';
import { normalizeSearchProductions } from '../transformers';
import type { EntityReportAdapter, EntityReportConfigureFormProps } from './EntityReportAdapter';

export const SUBMISSION_REPORT_ADAPTER_KEY = 'submission-report-adapter';

export const submissionEntityReportAdapter: EntityReportAdapter = {
    key: SUBMISSION_REPORT_ADAPTER_KEY,
    entity: ENTITIES.submission,
    defaultReportPageSize: 200,
    normalizeRows: (rows, locale) => normalizeSearchProductions(rows as Production[], locale),
    getConfigureFormComponent: () =>
        function SubmissionSortConfigFormItems(props: EntityReportConfigureFormProps) {
            return createElement(SortConfigFormItems, props);
        }
};
